/**
 * The app's toasts, in a layer of their own directly under `document.body`
 * (jorigin/brewauth#29 GB8 fix round 1).
 *
 * An open dialog makes every other child of the body `inert`
 * (`components/common/inertBackground.ts`). Rendered inside `#root`, the
 * Toaster went inert with the page: a toast raised while a dialog was open
 * ("Created …", "Deleted …") was not announced, and a toast's own button
 * (Dismiss on "No AMEEs online") could not be clicked. This layer is marked
 * `data-inert-exempt`, which `inertBackground` skips.
 */
import { createPortal } from 'react-dom';
import { Toaster } from 'react-hot-toast';

export default function ToastLayer() {
  return createPortal(
    <div data-inert-exempt="" data-testid="toast-layer">
      <Toaster
        position="top-right"
        // react-hot-toast's 16px inset, plus the CAPCO banners (#2271).
        containerStyle={{
          zIndex: 10000,
          top: 'calc(16px + var(--capco-banner-h, 0px))',
          bottom: 'calc(16px + var(--capco-banner-h, 0px))',
        }}
        toastOptions={{
          duration: 5000,
          className: 'mb-toast',
          success: {
            className: 'mb-toast mb-toast-success',
            iconTheme: { primary: '#3cb4e5', secondary: '#0a0f1e' },
          },
          error: {
            className: 'mb-toast mb-toast-error',
            iconTheme: { primary: '#f43f5e', secondary: '#0a0f1e' },
          },
          loading: {
            iconTheme: { primary: '#7cc8e8', secondary: '#0a0f1e' },
          },
        }}
      />
    </div>,
    document.body,
  );
}
